
export interface IStaffManagementParams {
  /** 员工姓名 */
  staffName?: string;
  /** 员工编号 */
  staffNo?: string;
  /** 门店ID */
  storeId?: string;
  /** 当前页码（从1开始） */
  page?: number;
  /** 每页显示条数 */
  size?: number;
  /** 公司ID */
  companyId?: number;
}

export interface IStaffManagement {
  /** 员工姓名 */
  staffName?: string;
  /** 员工编号 */
  staffNo?: string;
  /** 门店名称*/
  storeName?: string;
  /** 联系电话*/
  staffPhone?: string;
  /** 员工ID*/
  staffId?: string;
  /** 门店ID*/
  storeId?: string;
}

export interface IStaffManagementAddParams {
  /** 员工姓名 */
  staffName?: string;
  /** 员工手机号 */
  staffPhone?: string;
  /** 门店ID */
  storeId?: number;

}

export interface IStaffManagementEditParams extends IStaffManagementAddParams {
  /**
   *  用户id
   */
  fromUserId?: number | string;
  /**
   *  id
   */
  staffId?: number;
  /**
   *  企业id
   */
  companyId?: number;
  companyName?: string;
}

export interface IStoreManagementParams {
  /** 门店姓名 */
  storeName?: string;
  /** 门店编号 */
  storeNo?: string;
  /** 门店ID */
  storeId?: string;
  /** 当前页码（从1开始） */
  page?: number;
  /** 每页显示条数 */
  size?: number;
  /** 公司ID */
  companyId?: number;
}

export interface IStoreManagement {
  /** 门店联系人 */
  contactName?: string;
  /** 门店编号 */
  storeNo?: string;
  /** 门店名称*/
  storeName?: string;
  /** 门店联系方式*/
  contactPhone?: string;
  /** 员工ID*/
  staffId?: string;
  /** 门店ID*/
  storeId?: string;
  /** 省*/
  province?: string;
  /** 市*/
  city?: string;
  /** 区*/
  district?: string;
  /** 详细地址*/
  storeAddress?: string;
  /** 门店状态*/
  status?: string;
  /** 门店地址全称 */
  fullAddress?: string;
}

export interface IStoreManagementAddParams {
  /** 门店名称 */
  storeName: string;
  /** 门店联系人 */
  contactName: string;
  /** 联系人电话 */
  contactPhone: string;
  /** 省 */
  province: string;
  /** 市 */
  city: string;
  /** 区*/
  district: string;
  /** 详细地址 */
  storeAddress: string;

}

export interface IStoreManagementEditParams extends IStoreManagementAddParams {
  /**
   *  id
   */
  storeId?: number;

  companyId?: number;
  companyName?: string;
}

/** 门店状态 */
export enum EStoreStatus {
  /** 停用 */
  Disabled = 0,
  /** 启用 */
  Enabled = 1,
}

export const storeStatusLabel = {
  [EStoreStatus.Disabled]: '停用',
  [EStoreStatus.Enabled]: '启用',

};

export interface IStoreStaffItem {
  /** 用户id */
  userId: number;
  /** 用户名 */
  name: string;
  /** 手机号 */
  phone: string;
}

export interface IStoreChangePhoneApplyParams {
  /** 门店ID */
  storeId?: number;
  /** 支付手机号 */
  companyPayPhone?: string;
  /** 验证码 */
  verifyCode?: string;
}

export interface IStoreChangePhoneVerifyParams {
  /** 门店ID */
  storeId?: number;
  /** 新手机号 */
  mobile?: string;
  /** 验证码 */
  verifyCode?: string;
  /** 验证token */
  token?: string;
}
